import { render, staticRenderFns } from "./add-to-cart-stockcode-only.vue?vue&type=template&id=639785f8"
import script from "./add-to-cart-stockcode-only.vue?vue&type=script&lang=js"
export * from "./add-to-cart-stockcode-only.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports